(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sale-hero"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('sale-countdown')) {
		customElements.define('sale-countdown', class extends HTMLElement {
			connectedCallback() {
				const end = Date.parse(this.dataset.end);
				const units = this.querySelectorAll('[data-unit]');
				const tick = () => {
					let left = Math.max(0, Math.floor((end - Date.now()) / 1000));
					[86400, 3600, 60, 1].forEach((size, i) => {
						units[i].textContent = String(Math.floor(left / size)).padStart(2, '0');
						left %= size;
					});
					if (end > Date.now()) this.timer = setTimeout(tick, 1000);
				};
				tick();
			}
			disconnectedCallback() {
				clearTimeout(this.timer);
			}
		});
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sale-products"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('sale-products')) {
		customElements.define('sale-products', class extends HTMLElement {
			connectedCallback() {
				const grid = this.querySelector('.sale-products__grid');
				const items = Array.from(grid.children);
				const tabs = this.querySelectorAll('.sale-products__tabs button');
				const byIndex = (a, b) => a.dataset.index - b.dataset.index;
				const sorters = {
					'title': (a, b) => a.dataset.title.localeCompare(b.dataset.title),
					'price-ascending': (a, b) => a.dataset.price - b.dataset.price || byIndex(a, b),
					'price-descending': (a, b) => b.dataset.price - a.dataset.price || byIndex(a, b)
				};

				tabs.forEach((tab) => {
					const id = tab.dataset.tab;
					tab.hidden = id !== '' && !items.some((item) => item.dataset.tab === id);
					tab.addEventListener('click', () => {
						tabs.forEach((t) => {
							t.classList.toggle('active', t === tab);
							t.setAttribute('aria-pressed', t === tab);
						});
						items.forEach((item) => (item.hidden = id !== '' && item.dataset.tab !== id));
					});
				});

				this.querySelector('.sale-products__toolbar select')?.addEventListener('change', (event) => {
					grid.append(...items.sort(sorters[event.target.value] || byIndex));
				});
			}
		});
	}

  } catch(e) { console.error(e); }
})();
})();
